







































import Vue, { DirectiveOptions, VNode } from "vue";
import JzIcon from "../image/JzIcon.vue";
import chevronDownIcon from "../../assets/icons/transparent/ChevronDown.svg";
import { DirectiveBinding } from "vue/types/options";

interface Option<T> {
  display: string;
  value: T;
}

interface PositionCalculator {
  (el: HTMLElement, context: Vue, placement: Placement): void;
}

interface Placement {
  top: string;
  left: string;
  width: string;
}

interface CustomVue extends Vue {
  appendToBody?: boolean;
  calculatePosition?: PositionCalculator | undefined;
}

interface CustomVNode extends VNode {
  context?: CustomVue;
}

interface CustomHTMLElement extends HTMLElement {
  unbindPosition?: (() => void) | undefined;
}

export type CustomDirectiveFunction = (
  el: CustomHTMLElement,
  binding: DirectiveBinding,
  vnode: CustomVNode,
  oldVnode: VNode
) => void;

interface AppendToBodyDirective extends DirectiveOptions {
  inserted?: CustomDirectiveFunction;
  unbind?: CustomDirectiveFunction;
}

const appendToBodyDirective: AppendToBodyDirective = {
  inserted(el, bindings, { context }) {
    if (context && context.appendToBody) {
      const { height, top, left, width } = (context.$refs
        .toggle as Element).getBoundingClientRect();

      context.calculatePosition &&
        context.calculatePosition(el, context, {
          width: width + "px",
          top: window.scrollY + top + height + "px",
          left: window.scrollX + left + "px"
        });

      document.body.appendChild(el);
    }
  }
};

interface Data {
  chevronDownIcon: string;
  isOpen: boolean;
}

interface Methods {
  calculatePosition: PositionCalculator;
  handleClick: () => void;
  selectOption: (index: number, value: any) => void;
}

interface Props {
  appendToBody: boolean;
  iconSrc?: string;
  options: Option<any>[];
  title: string;
  value: string;
}

export default Vue.extend<Data, Methods, {}, Props>({
  name: "JzDropdownButton",
  components: {
    JzIcon
  },
  directives: {
    appendToBody: appendToBodyDirective
  },
  props: {
    appendToBody: {
      type: Boolean,
      default: true
    },
    options: { type: Array, required: true },
    iconSrc: { type: String, default: "" },
    title: { type: String, required: true },
    value: { type: String, default: "" }
  },
  data() {
    return {
      chevronDownIcon,
      isOpen: false
    };
  },
  methods: {
    calculatePosition(dropdownList, _component, { width, top, left }) {
      dropdownList.style.top = top;
      dropdownList.style.left = left;
      dropdownList.style.width = width;
    },
    handleClick() {
      this.isOpen = !this.isOpen;
    },
    selectOption(index, value) {
      (this.$listeners["selected"] as Function)(index, value);
      this.isOpen = false;
    }
  }
});
